import { today, todayPlus } from '../../lib/date';

/**
 * Sprint hai tuần bắt đầu từ hôm nay — mặc định của **mọi** nút tạo sprint.
 *
 * Ở chung một chỗ chứ không mỗi nút một bản: hai nút tạo sprint cho ra hai độ
 * dài mặc định khác nhau là thứ không ai giải thích được, và velocity thì so
 * các sprint với nhau nên độ dài mặc định lệch nhau làm lệch cả phép so.
 *
 * ⚠️ Ngày của **tổ chức**, không phải của UTC — APM-TZ-i. `setUTCHours(0)` trên
 * `new Date()` cho ra hôm qua lúc sáng sớm giờ Việt Nam.
 */
export function defaultSprintRange(): { startDate: string; endDate: string } {
  return { startDate: today(), endDate: todayPlus(13) };
}
